import { isPublicRoute as isPublicRouteUtil, isNotFoundRoute as isNotFoundRouteUtil } from "@surgia/utils";

export const HUB_PUBLIC_ROUTES = {
  REGISTER: "/register",
  LOGIN: "/login", 
  VERIFY_INVITATION: "/verify-invitation",
  WRONG_PORTAL: "/wrong-portal",
  SIGN_OUT: "/sign-out",
  NOT_FOUND: "*",
} as const;

export const HUB_PROTECTED_ROUTES = {
  HOME: "/",
  DASHBOARD: "/dashboard",
  BRANCHES: "/branches",
  BRANCH_DETAILS: "/branches/:id/:branch_name",
  USERS: "/users",
  USER_DETAILS: "/users/:userId",
  CATALOG: "/catalog",
  PURCHASE_REQUESTS: "/purchase-requests",
  PURCHASE_ORDER_CREATION: "/purchase-order/edit",
  PURCHASE_ORDER_VIEW: "/purchase-order/:id/view",
} as const;

export const isPublicRoute = (pathname: string): boolean => {
  return isPublicRouteUtil(pathname, HUB_PUBLIC_ROUTES);
};

export const isNotFoundRoute = (pathname: string): boolean => {
  return (
    isNotFoundRouteUtil(pathname, HUB_PUBLIC_ROUTES, HUB_PROTECTED_ROUTES)
  );
};




